import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import UserIcon from "../../assets/images/icon/users.jpg";
import ChatIcon from "../../assets/images/icon/chat.png";
import UploadIcon from "../../assets/images/icon/Upload.png";
import UserNavIcon from "../../assets/images/icon/user.png";
import SettingIcon from "../../assets/images/icon/gear.png";
import { MdContactPage, MdToken, MdPsychology } from "react-icons/md";
import { useLang } from "../../context/LanguageContext";

import LogoutModal from "../LogoutModal";

const NAV_ITEMS_EN = [
  // { label: "CHAT IA",        path: "/chat",            icon: ChatIcon },
  // { label: "DOCUMENT UPLOAD", path: "/document-upload", icon: UploadIcon },
  { label: "USER ADMIN", path: "/user-admin", icon: UserNavIcon },
  { label: "AI TRAINING", path: "/ai-training", icon: SettingIcon },
  { label: "TOKEN USAGE", path: "/dashboard", iconComponent: MdToken },
  { label: "CONTACT PLANS", path: "/contact-plan", iconComponent: MdContactPage },
  // { label: "ORG PROMPT", path: "/ai-rules", iconComponent: MdPsychology },
];

const NAV_ITEMS_ES = [
  // { label: "CHAT IA",           path: "/chat",            icon: ChatIcon },
  // { label: "SUBE UN DOCUMENTO", path: "/document-upload", icon: UploadIcon },
  { label: "ADMINISTRADOR", path: "/user-admin", icon: UserNavIcon },
  { label: "ENTRENAMIENTO IA", path: "/ai-training", icon: SettingIcon },
  { label: "USO DE TOKENS", path: "/dashboard", iconComponent: MdToken },
  { label: "PLANES CONTACTO", path: "/contact-plan", iconComponent: MdContactPage },
  // { label: "REGLAS IA ORG", path: "/ai-rules", iconComponent: MdPsychology },
];

const Sidebar = () => {
  const navigate = useNavigate();
  const { lang, handleLangToggle } = useLang();
  const [imagePreview, setImagePreview] = useState(null);
  const [username, setUsername] = useState("ADMIN");
  const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem("linko_admin_details");
      if (raw) {
        const details = JSON.parse(raw);
        const name = details?.name || details?.username || details?.email || "ADMIN";
        setUsername(name);
      }
    } catch (_) { }
    const GroupImage = localStorage.getItem("groupImage");
    if (GroupImage && GroupImage !== "undefined") setImagePreview(GroupImage);
    else setImagePreview(null);
  }, []);

  const handleLogOutConfirm = () => {
    setIsLogoutModalOpen(false);
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div
      className="flex flex-col justify-between min-h-screen w-full pt-8 pb-8"
      style={{ background: "linear-gradient(180deg, #1A0E3E 0%, #4F2A71 60%, #904DB0 100%)" }}
    >
      <div className="w-full flex flex-col items-center gap-4">
        {/* ENG / ESP toggle */}
        <div
          className="flex items-center rounded-[22.5px] border-[3px] border-[#C7BFE5] h-[42px] min-w-[160px] overflow-hidden "
        >
          <button
            onClick={() => handleLangToggle("EN")}
            className="flex-1 h-full flex items-center justify-center font-roboto font-extrabold text-[11px] uppercase leading-none transition-all"
            style={{
              color: lang === "EN" ? "#1A0E3E" : "#C7BFE5",
              background: lang === "EN" ? "#C7BFE5" : "transparent",
              borderRadius: lang === "EN" ? "9999px" : "0",
            }}
          >
            ENG
          </button>
          <button
            onClick={() => handleLangToggle("ES")}
            className="flex-1 h-full flex items-center justify-center font-roboto font-extrabold text-[11px] uppercase leading-none transition-all"
            style={{
              color: lang === "ES" ? "#1A0E3E" : "#C7BFE5",
              background: lang === "ES" ? "#C7BFE5" : "transparent",
              borderRadius: lang === "ES" ? "9999px" : "0",
            }}
          >
            ESP
          </button>
        </div>

        {/* Profile circle */}
        <div
          className="rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden mt-16"
          style={{
            width: "133.21px",
            height: "133.21px",
            background: "linear-gradient(to bottom, #904DB0, #C7BFE5)",
          }}
        >
          {imagePreview ? (
            <img src={imagePreview} alt="Preview" className="w-full h-full object-cover rounded-full" />
          ) : (
            <img src={UserIcon} alt="user" className="w-full h-full object-cover rounded-full" />
          )}
        </div>

        {/* Username */}
        <p
          className="font-roboto font-bold uppercase text-center leading-none mt-8 text-base"
          style={{ color: "#904DB0" }}
        >
          {username}
        </p>

        {/* Org / Company */}
        {/* <p
          className="font-roboto font-bold uppercase text-center leading-none text-white"
          style={{ fontSize: "18px", marginTop: "19px" }}
        >
          {groupname}
        </p> */}

        {/* Nav items */}
        <div className="grid gap-2 w-full mt-6 px-3">
          {(lang === "EN" ? NAV_ITEMS_EN : NAV_ITEMS_ES).map((item) => {
            const isActive = window.location.pathname.includes(item.path);
            return (
              <div key={item.path} onClick={() => navigate(item.path)} className="cursor-pointer">
                <button
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-xl font-roboto font-semibold text-sm text-white transition-all ${isActive
                      ? "bg-white/20 border border-white/40"
                      : "bg-transparent border border-transparent hover:bg-white/10"
                    }`}
                >
                  {item.iconComponent
                    ? <item.iconComponent className="h-5 w-5 flex-shrink-0 text-white" />
                    : <img src={item.icon} alt={item.label} className="h-5 w-5 object-contain flex-shrink-0 brightness-0 invert" />
                  }
                  {item.label}
                </button>
              </div>
            );
          })}
        </div>
      </div>

      {/* Bottom buttons */}
      <div className="w-full flex flex-col items-center gap-2 px-3">
        <button
          onClick={() => setIsLogoutModalOpen(true)}
          className="font-roboto font-bold text-[18px] uppercase text-[#1A0E3E] leading-none rounded-[6px] bg-[#C7BFE5] hover:bg-[#b5acd6] transition-all cursor-pointer"
          style={{ width: "217.84px", height: "37.39px" }}
        >
          {lang === "EN" ? "LOG OUT" : "CERRAR SESIÓN"}
        </button>
      </div>

      {/* Logout Confirmation Modal */}
      <LogoutModal
        isOpen={isLogoutModalOpen}
        onClose={() => setIsLogoutModalOpen(false)}
        onConfirm={handleLogOutConfirm}
        lang={lang}
      />
    </div>
  );
};

export default Sidebar;
